module.exports = __webpack_public_path__ + "static/media/Error.97401a68.svg";